// extracted by mini-css-extract-plugin
module.exports = {"cartIsfcUser":"inxed_cartIsfcUser__7nfgs"};